import React, { useState } from 'react';
import { activateWarranty } from './api';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function ActivationForm({ registration, onClose }) {
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [buyFrom, setBuyFrom] = useState('');
  const [productName, setProductName] = useState('');
  const [customerCode, setCustomerCode] = useState('');
  const [buyDate, setBuyDate] = useState(''); // will hold Shamsi string like 1404-07-01
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const payload = {
        registration_id: registration.id,
        email,
        address,
        city,
        buyFrom,
        productName,
        customerCode,
        buyDate, // Jalali date string
      };
      const res = await activateWarranty(payload);
      if (res.success) {
        setSuccessMsg('گارانتی با موفقیت فعال شد ✅');
        setTimeout(() => onClose(), 1000);
      } else {
        setError(res.message || 'فعال‌سازی ناموفق بود');
      }
    } catch (err) {
      setError(err.message || 'خطای سرور');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal">
      <div className="card">
        <h3 style={{ marginTop: 0 }}>فعال‌سازی گارانتی محصول</h3>
        <form onSubmit={onSubmit}>
          <div className="form-row"><label>شماره سریال</label><input value={registration.product_serial_number} readOnly /></div>
          <div className="form-row"><label>نام خریدار</label><input value={registration.person_name} readOnly /></div>
          <div className="form-row"><label>تلفن تماس</label><input value={registration.phone_number} readOnly /></div>

          <div className="form-row"><label>نام محصول *</label><input required value={productName} onChange={e => setProductName(e.target.value)} /></div>
          <div className="form-row"><label>کد مشتری *</label><input required value={customerCode} onChange={e => setCustomerCode(e.target.value)} /></div>

          {/* ✅ Jalali Date Picker */}
          <div className="form-row">
            <label>تاریخ خرید *</label>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              value={buyDate}
              onChange={date => setBuyDate(date?.format("YYYY-MM-DD"))}
              format="YYYY-MM-DD"
              required
              
            />
            {buyDate && (
              <small style={{ display: 'block', fontSize: '0.8em', marginTop: 4 }}>
                تاریخ انتخاب‌شده: <b>{buyDate}</b>
              </small>
            )}
          </div>

          <div className="form-row"><label>خرید از *</label><input required value={buyFrom} onChange={e => setBuyFrom(e.target.value)} /></div>
          <div className="form-row"><label>ایمیل *</label><input required type="email" value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="form-row"><label>آدرس *</label><textarea required value={address} onChange={e => setAddress(e.target.value)} /></div>
          <div className="form-row"><label>شهر *</label><input required value={city} onChange={e => setCity(e.target.value)} /></div>

          {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
          {successMsg && <div style={{ color: 'green', marginBottom: 8 }}>{successMsg}</div>}

          <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 8 }}>
            <button className="btn primary" type="submit" disabled={loading}>
              {loading ? 'در حال ذخیره...' : 'فعال‌سازی گارانتی'}
            </button>
            <button type="button" className="btn ghost" onClick={onClose}>انصراف</button>
          </div>
        </form>
      </div>
    </div>
  );
}
